import React, {  useState } from "react";
import { useTranslation } from "react-i18next";
import { withOidcSecure } from "@axa-fr/react-oidc";
import { appTheme } from "../../../../helpers/utils/Utils";
import { useDispatch, useSelector } from "react-redux";
import CustomAllocateFundDropdown from "../../../CustomComponents/CustomAllocateFundDropdown";
import { retrieveData } from "../../../../utils";
import {
  GetApiHeadersWithBearer,
  PostRequest,
} from "../../../../network/NetworkUtils";
import {
  MOVE_FUNDS,
  REMOVESAVINGGOAL,
  SAVING_CARD_CODE,
  STATUS_SUCCESS_CODE,
} from "../../../../network/URLConstants";

const TransaferFundsCompleteGoalModal = ({
  content1,
  btn1,
  transferBtn,
  btn2,
  btn2Function,
  icon,
}) => {
  const { t } = useTranslation();
  const accountObj = useSelector((state) => state.accountTypes);
  const dispatch = useDispatch();
  const kudzuPlusTrue = useSelector((state) => state.kudzuPlusTrue);
  const appThemeData = appTheme(kudzuPlusTrue);
  const [selectedAccountType, setSelectedAccountType] = useState("");
  const cards = useSelector((state) => JSON.parse(state.userCards));
  const accessToken = useSelector((state) => state.accessToken);
  const goalKeyData = useSelector((state) => state.savingGoalResponseData.goalKey );
  const AccountData = useSelector((state) => state.savingGoalAccountTypeObj);
  const SavingGoalId = useSelector((state) => state.savingGoals.GoalKey);
  const { AccountName, AccountType, AccountId } = selectedAccountType;

  const manageSavingDataObj = useSelector(
    (state) => state.manageSavingGoalDetailsObj
  );

  const setFrequencyFun = (value) => {
    setSelectedAccountType(value);
    dispatch({  type: "SAVING_GOAL_ACCOUNT_TYPE_OBJ",   payload: { savingGoalAccountTypeObj : value },  });
  };

  const handleTransfer = async () => {
    const modifiedData = {
      toAccount: AccountId,
      toAccountType: AccountType,
    };
    const deviceId = await retrieveData("updatedDeviceId");
    const headers = await GetApiHeadersWithBearer(deviceId, accessToken);
    const savingsAccount = cards.find(
      (account) => account.AccountTypeBit63 == SAVING_CARD_CODE
    );
   
    const url = MOVE_FUNDS(savingsAccount.CardKey, SavingGoalId);
    const response = await PostRequest(url, modifiedData, headers);
    const responseJson = JSON.parse(response);
    if (responseJson.ResponseCode === STATUS_SUCCESS_CODE) {
        transferBtn('success')
    } else {
      var arrMessages = responseJson.Messages;
      var message = arrMessages[0];
      var displayText = message.DisplayText;
        
        transferBtn(displayText)
    }
  };
  const AccountArrayData = accountObj.filter(item => item?.AccountName !== manageSavingDataObj?.goalName);
 

  return (
    <div className="flex flex-col flex-start w-full">
      <p className="font-hanken-grotesk lg:text-[19px] md:text-[19px] sm:text-[16px] mb-44 text-[14px] font-[400] sm:font-[500] leading-[24px] sm:leading-[22px] md:leading-[28px] text-[var(--modal-text-heading-clr)]">
        {content1}
      </p>
      <div className="flex flex-col gap-5 h-1/2 relative bottom-28">
        <div className="flex flex-col gap-3">
          <CustomAllocateFundDropdown
            options={
              AccountArrayData.length > 0
                ? AccountArrayData
                : [{ Name: t("no_linked_acccounts") }]
            }
            title={t("transfer to")}
            onSelect={setFrequencyFun}
            selectedAccountType={selectedAccountType}
            selectedFrequency={AccountName}
            hrbg="bg-dropdown-sky"
          />
        </div>
      </div>
      <div className="flex flex-col justify-center items-center w-full">
        <div className="flex flex-col justify-center items-center gap-8 w-full">
            {
                AccountName ? (
                    <button
                    className="font-hanken-grotesk lg:text-[18px] md:text-[17px] sm:text-[15px] text-[16px] font-[500] sm:font-bold leading-[24px] sm:leading-[12px] md:leading-[16px] bg-[#2965FB] text-white cursor-pointer border-2 px-2 py-4 border-[#2965FB] w-full"
                    onClick={() => handleTransfer()}
                    onKeyDown={(e) => {
                      if (e.key === "Enter") handleTransfer();
                    }}
                  >
                    {btn1}
                  </button>
                ) : (
                    <button
                    className="font-hanken-grotesk lg:text-[18px] md:text-[17px] sm:text-[15px] text-[16px] font-[500] sm:font-bold leading-[24px] sm:leading-[12px] md:leading-[16px] bg-[#4B70B9] text-white cursor-pointer border-2 px-2 py-4 border-[#4B70B9] w-full"
                  >
                    {btn1}
                  </button>
                )
            }
        

          {btn2 && (
            <button
              className="font-hanken-grotesk lg:text-[18px] md:text-[17px] sm:text-[15px] text-[16px] font-[500] sm:font-bold leading-[24px] sm:leading-[12px] md:leading-[16px] text-[var(--modal-btn-text-color)] cursor-pointer border-2 px-2 py-4 border-[#2965FB] sm:border-none w-full capitalize"
              onClick={() => btn2Function()}
              onKeyDown={(e) => {
                if (e.key === "Enter") btn2Function();
              }}
            >
              {btn2}
            </button>
          )}
        </div>
      </div>
    </div>
  );
};

export default withOidcSecure(TransaferFundsCompleteGoalModal);
